import Plausible from 'plausible-tracker'

class GTMService {
  plausible;

  load() {
    if (!this.plausible) {
      this.plausible = Plausible({
        domain: 'trainn.co',
        apiHost: 'https://trainn.co'
      })
    }
  }

  trackPageView() {
    if (this.plausible) {
      this.plausible.trackPageview();
    }
  }

  async pushEvent(eventName, userId) {
    if (this.plausible) {
      this.plausible.trackEvent(
        eventName,
        {

        }
      )
    }
  }
}

export default new GTMService();
